'use strict';

document.addEventListener('DOMContentLoaded', () => {
    const banners = document.querySelectorAll('.js-citrus-home-banner');
    banners.forEach(function getBanners(banner) {
        banner.addEventListener('click', function sendClick(event) {
            event.preventDefault();
            const url = this.getAttribute('href');
            if (url) {
                window.location.href = url;
            }
            const backendUrl = this.getAttribute('data-click-url');
            fetch(backendUrl, {
                method: 'GET'
            });
        });
    });
});


/**
 * Handles the click event for Citrus analytics tracking and optional PDP redirection.
 *
 * Sends a GET request to the provided Citrus tracking URL. Once the request completes,
 * the function redirects the user to the PDP URL if it's properly defined.
 *
 * @param {string} clickCitrusUrl - The URL for the Citrus tracking endpoint.
 * @param {string} pdpUrl - The Product Detail Page URL to redirect to (optional).
 */
function handleCictusClick(clickCitrusUrl, pdpUrl) {
    const shouldRedirect = typeof pdpUrl === 'string' && pdpUrl.trim() !== '';

    if (clickCitrusUrl) {
        $.ajax({
            url: clickCitrusUrl,
            method: 'GET',
            complete: function () {
                if (shouldRedirect) {
                    window.location.href = pdpUrl;
                }
            }
        });
    } else if (shouldRedirect) {
        window.location.href = pdpUrl;
    }
}


module.exports = {
    handleCictusClick
};
